<div class="order-detail__header">
  Loja - Detalhes do pedido
  {{ order?.reshipmentOrderId ? ' de Reenvio' : '' }}
</div>
<div class="order-detail__content" *ngIf="order">
  <div class="order-detail__content__left">
    <app-person-card
      *ngIf="person"
      [showProfileLink]="order.shop !== 'mensmarket'"
      [background]="order.shop === 'mensmarket' && 'blue'"
      [showResetPassword]="order.shop !== 'mensmarket'"
      [person]="person"
      [showProfileLink]="person?.personId > 0"
      [showResetPassword]="person?.personId > 0"
      [subscriptionId]="order.shop === 'mensmarket' ? 3 : 1"
    />
  </div>
  <div class="order-detail__content__right">
    <div class="card shipping-order">
      <span class="info">
        <strong>Loja:</strong>&nbsp;
        <span>{{ shopName }}</span>
      </span>
      <span class="info">
        <strong>ID</strong>:
        <span>{{ order.orderNumber || order.id }}</span>
      </span>
      <span class="info">
        <strong>Data do pedido</strong>:
        {{ order.createdAt | date: 'dd/MM/yyyy HH:mm' }}
      </span>
      <span class="info">
        <strong>Status</strong>:
        <span
          class="status"
          [class.change]="!pendingResend"
          [ngClass]="{
            'status--active': order.status === 'Entregue',
            'status--warning': isWarningStatus,
            'status--danger': order.status === 'Cancelado'
          }"
          (click)="!pendingResend && showDropdown()"
          *ngIf="!changeStatus"
        >
          {{ order.status }}
        </span>
        <span *ngIf="changeStatus && statusList">
          <p-dropdown
            [options]="statusList"
            [(ngModel)]="order.status"
            (onChange)="changeOrderStatus()"
            (onBlur)="changeStatus = false"
            appendTo="body"
            #status
            (onHide)="changeStatus = false"
            [autoDisplayFirst]="false"
            [placeholder]="order.status"
          />
        </span>
      </span>
      <span class="info">
        <strong>Cupom</strong>:
        {{ order?.coupon?.nickname || 'Sem cupom' }}
      </span>
      <span class="info">
        <strong>Desconto</strong>:
        {{ couponDiscountLabel || 'Sem desconto' }}
      </span>
      <span class="info">
        <strong>PedidoV</strong>: {{ order?.pedidov || 'Não informado' }}
      </span>
      <span class="info" *ngIf="order.orderTiny">
        <strong>OrderTiny</strong>: {{ order.orderTiny }}
      </span>
      <span class="info" *ngIf="order?.reshipmentOrderId">
        <strong>Pedido original</strong>:&nbsp;
        <a
          [routerLink]="'/shop-orders/order/' + order.reshipmentOrderId"
          class="data-link"
          [class.data-link--mens]="order.shop === 'mensmarket'"
          target="_blank"
        >
          {{ order.reshipmentOrderId }}
        </a>
      </span>
      <div class="resend-info" *ngIf="shippingOrderRequest">
        <span class="info">
          <strong>Ticket</strong>:&nbsp;
          <a
            [href]="
              'https://b4asupport.zendesk.com/agent/tickets/' +
              shippingOrderRequest.ticketId
            "
            target="_blank"
            class="data-link"
            style="text-decoration: underline"
            pTooltip="Ver ticket no Zendesk"
            tooltipPosition="bottom"
          >
            {{ shippingOrderRequest.ticketId || 'Não informado' }}
          </a>
        </span>
        <span class="info">
          <strong>Origem do Ticket</strong>:
          {{ shippingOrderRequest.ticketOrigin || 'Não informado' }}
        </span>
        <span class="info full-w" *ngIf="shippingOrderRequest.ticketDetail">
          {{ shippingOrderRequest.ticketDetail }}
        </span>
      </div>
      <div class="shipping-summary">
        <span class="info"
          ><strong>Frete</strong>:&nbsp;
          <ng-container *ngIf="order.shipping?.ShippingPrice">
            {{ order.shipping.ShippingPrice | currency: 'BRL' }}
          </ng-container>
          <ng-container *ngIf="!order.shipping?.ShippingPrice">
            Grátis
          </ng-container>
        </span>
        <span
          class="info"
          *ngIf="order.shipping?.description || order.shipping?.DaysToDelivery"
        >
          <strong>Prazo de entrega</strong>:
          {{
            order.shipping?.description ||
              order.shipping?.DaysToDelivery + ' dia(s)'
          }}
          <p-button
            size="small"
            styleClass="p-button-xs"
            severity="primary"
            icon="pi pi-truck"
            [rounded]="true"
            (onClick)="openTracking()"
            pTooltip="Ver rastreio"
            *ngIf="order.shipping?.invoiceNumber && tracking?.length"
          />
        </span>
        <span class="info">
          <strong>Transportadora</strong>:
          <ng-container *ngIf="!updateCompany">
            {{
              shippingCompany?.shippingServiceName ||
                shippingCompany?.shippingCompanyName ||
                'Não informado'
            }}
          </ng-container>
          <p-button
            icon="pi pi-pencil"
            styleClass="p-button-xs p-button-primary"
            [text]="true"
            size="small"
            [pTooltip]="
              shippingCompanyId
                ? 'Alterar transportadora'
                : 'Selecionar transportadora'
            "
            tooltipPosition="bottom"
            *ngIf="
              canUpdateShippingCompany &&
              shippingCompanies?.length > 0 &&
              !updateCompany
            "
            (onClick)="updateShippingCompany()"
          />
          <p-dropdown
            [options]="shippingCompanies"
            [(ngModel)]="shippingCompanyId"
            optionLabel="shippingServiceName"
            optionValue="id"
            (onBlur)="updateCompany = false"
            (onHide)="updateCompany = false"
            [autoDisplayFirst]="false"
            appendTo="body"
            [filter]="true"
            #companies
            (onChange)="saveShippingCompany($event.value)"
            [placeholder]="
              shippingCompany?.shippingServiceName ||
              shippingCompany?.shippingCompanyName ||
              'Selecione a transportadora'
            "
            *ngIf="canUpdateShippingCompany && updateCompany"
          />
        </span>
        <span class="info">
          <strong>NF</strong>:
          {{ order?.shipping?.invoiceNumber || 'Sem nota fiscal' }}
        </span>
        <span class="info">
          <strong>Código de rastreio</strong>:
          {{ order?.trackingCode || 'Rastreio não disponível' }}
        </span>
        <span class="info" *ngIf="order?.trackingUrl">
          <strong>URL de rastreio</strong>:
          <a [href]="order.trackingUrl" target="_blank">
            {{ order.trackingUrl }}
          </a>
        </span>
        <span
          class="info info--full"
          *ngIf="
            order?.shippingAddress?.street &&
            order?.shippingAddress?.city &&
            order?.shippingAddress?.state
          "
        >
          <strong>Endereço</strong>:
          {{ order.shippingAddress.street }}
          {{ order.shippingAddress.number
          }}<span *ngIf="order.shippingAddress.extension?.length"
            >, {{ order.shippingAddress.extension }}</span
          >
          - {{ order.shippingAddress.district }},
          {{ order.shippingAddress.city }} - {{ order.shippingAddress.state }},
          Brasil, CEP
          {{ order.shippingAddress.zip }}
        </span>
        <span
          class="info info--full"
          *ngIf="order.shipping?.additionalDescription"
        >
          <strong>Detalhes</strong>:
          {{ order.shipping?.additionalDescription }}
        </span>
      </div>
      <div class="payment-summary">
        <span>
          <p>
            <strong>
              <i
                class="pi"
                [class.pi-barcode]="
                  order.payment?.payment_method === 'boleto' ||
                  order.payment?.paymentMethod === 'boleto'
                "
                [class.pi-qrcode]="
                  order.payment?.payment_method === 'pix' ||
                  order.payment?.paymentMethod === 'pix'
                "
                [class.pi-credit-card]="
                  order.payment?.payment_method === 'credit_card' ||
                  order.payment?.paymentMethod === 'credit_card'
                "
              ></i>
              {{ methodName | titlecase }}
            </strong>
          </p>
          <p *ngIf="order.payment?.id">
            <strong>ID Pagamento</strong>:
            <a
              *ngIf="paymentGatewayUrl"
              class="data-link"
              [href]="paymentGatewayUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ order.payment?.id }}
            </a>
            <ng-container *ngIf="!paymentGatewayUrl">{{
              order.payment?.id
            }}</ng-container>
          </p>
          <p
            *ngIf="order.payment?.acquirerName || order.payment?.acquirer_name"
          >
            <strong>Gateway</strong>:
            {{
              order.payment?.acquirerName || order.payment?.acquirer_name
                | titlecase
            }}
          </p>
          <p>
            <strong>Valor</strong>:
            {{ order.totalPrice | currency: 'BRL' }}
            <ng-container *ngIf="order.payment?.installments > 1">
              em {{ order.payment?.installments }}x de
              {{
                order.totalPrice / order.payment?.installments | currency: 'BRL'
              }}
            </ng-container>
            <ng-container *ngIf="order.payment?.installments === 1">
              à vista
            </ng-container>
            <span
              class="status"
              [ngClass]="{
                'status--active': order.payment?.status === 'paid',
                'status--warning':
                  order.payment?.status === 'waiting_payment' ||
                  order.payment?.status === 'pending' ||
                  order.payment?.status === 'processing',
                'status--danger':
                  order.payment?.status === 'Estornado' ||
                  order.payment?.status === 'canceled' ||
                  order.payment?.status === 'refunded' ||
                  order.payment?.status === 'Cancelado'
              }"
            >
              {{ paymentStatus }}
            </span>
          </p>
          <app-credit-card-view
            *ngIf="order.payment?.card"
            [creditCard]="order.payment?.card"
          />
          <ng-container
            *ngIf="
              !order.payment?.card && order.payment?.paymentMethod === 'boleto'
            "
          >
            <p
              *ngIf="
                order.payment?.boletoExpirationDate &&
                order.payment?.status !== 'paid'
              "
            >
              <strong>Vencimento: </strong>
              {{ order.payment?.boletoExpirationDate | date: 'dd/MM/yyyy' }}
              <strong
                *ngIf="expired"
                [pTooltip]="getTooltip()"
                tooltipPosition="bottom"
              >
                &nbsp;<i class="pi pi-calendar-times"></i
              ></strong>
            </p>
            <p *ngIf="order.payment?.paidAt">
              <strong>Data pagamento: </strong
              >{{ order.payment?.paidAt | date: 'dd/MM/yyyy HH:mm:ss' }}
            </p>
            <p *ngIf="boletoBarCode && order.payment?.status !== 'paid'">
              <strong>Código de barras:</strong>
              <a
                class="data-link"
                type="button"
                (click)="copyToClipboard(boletoBarCode)"
                [pTooltip]="getTooltip('boletoBarcode')"
                tooltipPosition="bottom"
                >{{ boletoBarCode
                }}<span class="copy"> &nbsp;<i class="pi pi-copy"></i></span>
              </a>
            </p>
            <p
              *ngIf="order.payment?.boletoUrl"
              [pTooltip]="getTooltip('boletoUrl')"
              tooltipPosition="bottom"
            >
              <strong>URL:</strong>
              <a
                class="data-link"
                [class.data-link--line-through]="
                  order.payment.status === 'paid' || expired
                "
                [href]="order.payment?.boletoUrl"
                target="_blank"
                >{{ order.payment?.boletoUrl
                }}<span class="copy" *ngIf="order.payment.status !== 'paid'">
                  &nbsp;<i
                    class="pi"
                    [class.pi-external-link]="!expired"
                    [class.pi-calendar-times]="expired"
                  ></i
                ></span>
              </a>
              <strong *ngIf="order.payment.status === 'paid'">
                &nbsp;<i class="pi pi-verified"></i>
              </strong>
            </p>
          </ng-container>
          <ng-container
            *ngIf="
              !order.payment?.card && order.payment?.payment_method === 'pix'
            "
          >
            <p *ngIf="pixExpirationDate && order.payment?.status !== 'paid'">
              <strong>Vencimento/Expiração do PIX: </strong>
              {{ pixExpirationDate | date: 'dd/MM/yyyy HH:mm' }}
              <strong
                *ngIf="expired"
                [pTooltip]="getTooltip()"
                tooltipPosition="bottom"
              >
                &nbsp;<i class="pi pi-calendar-times"></i
              ></strong>
            </p>
            <p *ngIf="order.payment?.paidAt">
              <strong>Data pagamento: </strong>
              {{ order.payment.paidAt | date: 'dd/MM/yyyy HH:mm:ss' }}
            </p>
            <p *ngIf="codigoPix">
              <strong>Código PIX:</strong>
              <a
                class="data-link"
                type="button"
                (click)="copyToClipboard(codigoPix)"
                [class.data-link--line-through]="
                  order.payment.status === 'paid'
                "
                [pTooltip]="getTooltip('pixQrcode')"
                tooltipPosition="bottom"
              >
                {{ order.payment.pix_qr_code || order.payment.pixQrcode }}
                <i class="pi pi-copy"></i>
              </a>
            </p>
          </ng-container>
        </span>
        <span class="payment-summary__summary">
          <h3>Resumo</h3>
          <p *ngIf="order.shop !== 'Glampoints'">
            <strong>Subtotal:</strong>
            <span>{{ productsTotal | currency: 'BRL' }}</span>
          </p>
          <p *ngIf="order.shipping?.ShippingPrice">
            <strong>Entrega:</strong>
            <span>{{ order.shipping?.ShippingPrice | currency: 'BRL' }}</span>
          </p>
          <p *ngIf="!order.shipping?.ShippingPrice">
            <strong>Entrega:</strong><span>Grátis</span>
          </p>
          <p *ngIf="shippingDiscount > 0">
            <strong>Desconto frete (-):</strong>
            <span class="payment-summary__discount">{{
              shippingDiscount | currency: 'BRL'
            }}</span>
          </p>
          <p *ngIf="subscriberDiscount > 0 && order.shop !== 'Glampoints'">
            <strong>Desconto clube (-):</strong>
            <span class="payment-summary__discount">{{
              subscriberDiscount | currency: 'BRL'
            }}</span>
          </p>
          <p *ngIf="order.discount && order.shop !== 'Glampoints'">
            <strong>Cupom (-):</strong>
            <span class="payment-summary__discount">
              {{ order.discount | currency: 'BRL' }}</span
            >
          </p>
          <p *ngIf="pointsUsed > 0">
            <strong>Pontos usados:</strong>
            <span>{{ pointsUsed }}</span>
          </p>
          <p *ngIf="pointsDiscount > 0">
            <strong>Desconto glampoints (-):</strong>
            <span class="payment-summary__discount">{{
              pointsDiscount | currency: 'BRL'
            }}</span>
          </p>
          <p>
            <strong>Total:</strong>
            <span>{{ order.totalPrice | currency: 'BRL' }}</span>
          </p>
          <p *ngIf="refunds?.length">
            <strong>* Estornos (-):</strong>
            <span class="payment-summary__discount">{{
              refundedAmount | currency: 'BRL'
            }}</span>
          </p>
        </span>
      </div>
      <span class="buttons" *ngIf="order.shop !== 'Glampoints'">
        <ng-container *ngIf="!isReshipment && order.status !== 'Cancelado'">
          <p-button
            label="Cancelar pedido"
            severity="danger"
            (onClick)="refundShoppingOrder(true)"
          />
          <p-button
            label="Cancelar produto(s)"
            styleClass="p-button-primary"
            (onClick)="refundShoppingOrder()"
          />
        </ng-container>
        <ng-container *ngIf="pendingResend">
          <p-button
            label="Revalidar estoque"
            styleClass="p-button-primary"
            *ngIf="isReshipment && order.status !== 'Cancelado'"
            (onClick)="revalidateReshipmentStock()"
          />
          <p-button
            label="Aprovar reenvio"
            styleClass="p-button-success"
            *ngIf="
              shippingOrderRequest?.ticketId &&
              isReshipment &&
              order.status !== 'Cancelado'
            "
            (onClick)="approveReshipment(true)"
            [disabled]="!canApproveReshipment"
          />
          <p-button
            label="Reprovar reenvio"
            styleClass="p-button-danger"
            (onClick)="approveReshipment(false)"
          />
        </ng-container>
      </span>
    </div>
    <div class="card">
      <p-tabView
        [activeIndex]="selectedTab"
        (activeIndexChange)="tabChanged($event)"
      >
        <p-tabPanel header="Produtos">
          <p-message
            *ngIf="isReshipment && !hasValidStock"
            severity="warn"
            variant="outlined"
            text="Um ou mais produtos estão sem estoque. Clique em revalidar estoque para atualizar as informações de estoque dos produtos e aprovar o reenvio."
          ></p-message>

          <div class="order-detail__tab">
            <app-table
              [cols]="cols"
              *ngIf="order && tableReady"
              modelName="produtos"
              tableTitle="Itens do pedido"
              [elements]="products"
              [lazy]="false"
              [addButton]="false"
              [paginator]="false"
              [dropdownFilters]="tableFilters"
            />
          </div>
        </p-tabPanel>
        <p-tabPanel header="Endereços">
          <div class="order-detail__tab">
            <p-fieldset legend="Entrega">
              <app-shop-order-address-form
                *ngIf="order && states"
                [states]="states"
                [order]="order"
                type="shipping"
              />
            </p-fieldset>
            <p-fieldset legend="Cobrança">
              <app-shop-order-address-form
                *ngIf="order && states"
                [states]="states"
                [order]="order"
                type="billing"
              />
            </p-fieldset>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Estornos" *ngIf="refunds?.length">
          <div class="order-detail__tab">
            <app-table
              [cols]="refundedCols"
              *ngIf="order && tableReady"
              modelName="Estornos"
              tableTitle="Itens estornados"
              [elements]="refundedProducts"
              [lazy]="false"
              [addButton]="false"
              [defaultRows]="25"
            />
          </div>
        </p-tabPanel>

        <p-tabPanel header="Pagamentos">
          <div class="order-detail__tab">
            <app-table
              [cols]="paymentCols"
              *ngIf="order && tableReady"
              modelName="Pagamentos"
              tableTitle="Pagamentos do pedido"
              [elements]="orderPayments"
              [lazy]="false"
              [addButton]="false"
              [defaultRows]="25"
              [actionButtons]="paymentActionButtons"
              (actionButtonClick)="showPaymentTransactionModalAction($event)"
            />
          </div>
        </p-tabPanel>

        <p-tabPanel header="Logs/Updates">
          <div class="order-detail__tab">
            <app-table
              [cols]="logCols"
              *ngIf="order && tableReady"
              modelName="Logs"
              tableTitle="Logs do pedido"
              [elements]="orderLogs"
              [lazy]="false"
              [addButton]="false"
              [defaultRows]="25"
              [actionButtons]="logActionButtons"
              (actionButtonClick)="showOrderDocumentModal($event)"
            />
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showDocumentModal"
  header="Dados atualizados da order: {{ selectedDocument?.orderNumber }}"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <pre>{{ selectedDocument | json }}</pre>
</p-dialog>

<p-dialog
  [(visible)]="showPaymentTransactionModal"
  header="Transação do pagamento"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <pre>{{ selectedPaymentTransaction | json }}</pre>
</p-dialog>

<p-toast />
<p-confirmDialog />
